/* 2026-10-22 PurryPurry product cards: keep the swipe dots in sync and let a tap on the swipe area open the product. */
(function () {
  if (window.__ppCard) return;
  window.__ppCard = true;
  function sync(s) {
    var dots = s.parentElement && s.parentElement.querySelector('.pp-card-dots');
    if (!dots || !s.clientWidth) return;
    var i = Math.round(s.scrollLeft / s.clientWidth);
    for (var k = 0; k < dots.children.length; k++) dots.children[k].classList.toggle('is-on', k === i);
  }
  document.addEventListener('scroll', function (e) {
    var s = e.target;
    if (s && s.classList && s.classList.contains('pp-card-swipe')) sync(s);
  }, true);
  document.addEventListener('click', function (e) {
    var s = e.target && e.target.closest && e.target.closest('.pp-card-swipe');
    if (s && s.dataset.url) window.location.href = s.dataset.url;
  });
})();
